export default __webpack_public_path__ + "static/media/4.5e1b713a.jpg";